// Plugins
import { registerPlugins } from './plugins';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createSentryPiniaPlugin } from "@sentry/vue";
import { createPinia } from 'pinia'

import * as Sentry from "@sentry/vue";

const pinia = createPinia()

pinia.use(createSentryPiniaPlugin());


import {
  faAlbum,
  faAlbumCollection,
  faAngleDown,
  faArrowDownAZ,
  faArrowDownShortWide,
  faArrowDownWideShort,
  faArrowDownZA,
  faChevronDown,
  faChevronUp,
  faChevronsDown,
  faChevronLeft,
  faChevronRight,
  faChevronsLeft,
  faChevronsRight,
  faChevronsUp,
  faCirclePlay,
  faCircleXmark,
  faClockRotateLeft,
  faExclamationTriangle,
  faFilm,
  faGamepadModern,
  faHome,
  faLabel,
  faLeftToLine,
  faListMusic,
  faMagnifyingGlassMusic,
  faRightFromLine,
  faRightToLine,

  faTriangleExclamation,


} from '@awesome.me/kit-6ce8657579/icons/sharp-duotone/regular';

import {
  faPlay,
  faStop,
  faForward,
  faForwardStep,
  faBackward,
  faBackwardStep,
  faAngleLeft,
  faAngleRight,
  faXmark,
  faStopwatch,
  faBookOpen,
  faMusic,
  faFile,
  faClipboard,
  faSearch,

} from '@awesome.me/kit-6ce8657579/icons/slab-duo/regular'


import App from './App.vue'

import { createApp } from 'vue'

const app = createApp(App)
import router from './router'

Sentry.init({
  app,
  dsn: "https://7f903631be6ed6604921fa899aa29ee2@aramryu.com/5",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] })
  ],
  // Enable logs to be sent to Sentry
  enableLogs: true,
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

library.add(
  faAlbum,
  faAlbumCollection,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowDownAZ,
  faArrowDownShortWide,
  faArrowDownWideShort,
  faArrowDownZA,
  faBackward,
  faBackwardStep,
  faBookOpen,
  faClipboard,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faChevronsDown,
  faChevronsLeft,
  faChevronsRight,
  faChevronsUp,
  faCirclePlay,
  faCircleXmark,
  faClockRotateLeft,
  faExclamationTriangle,
  faFile,
  faFilm,
  faForward,
  faForwardStep,
  faGamepadModern,
  faHome,
  faLabel,
  faLeftToLine,
  faListMusic,
  faMagnifyingGlassMusic,
  faMusic,
  faPlay,
  faRightFromLine,
  faRightToLine,
  faSearch,
  faStop,
  faStopwatch,
  faTriangleExclamation,
  faXmark,
)

config.showMissingIcons = true;
// config.familyDefault = 'sharp-duotone';
// config.styleDefault = 'regular';

app.component('FontAwesomeIcon', FontAwesomeIcon) // Register component globally

registerPlugins(app)


app.use(pinia).mount('#app')
